import { Button } from '@montugroup/design-system';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

type MergePatientsModalFooterProps = {
  onCancel: () => void;
  onProceed: () => void;
  isProceedDisabled?: boolean;
  proceedLabel?: string;
};

const FooterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(8),
}));

const ProceedButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
}));

const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
}));

export const MergePatientsModalFooter = ({
  onCancel,
  onProceed,
  isProceedDisabled = false,
  proceedLabel = 'Ok',
}: MergePatientsModalFooterProps) => {
  return (
    <FooterContainer>
      <CancelButton onClick={onCancel} data-testid={'cancel-merge-button'}>
        Cancel
      </CancelButton>
      <ProceedButton
        variant={'contained'}
        onClick={onProceed}
        disabled={isProceedDisabled}
        data-testid="proceed-with-merge-button"
      >
        {proceedLabel}
      </ProceedButton>
    </FooterContainer>
  );
};
